import { render, staticRenderFns } from "./installationsTech.vue?vue&type=template&id=77b534f3&"
import script from "./installationsTech.vue?vue&type=script&lang=js&"
export * from "./installationsTech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports